/**
 * Page-size bounds for every paginated list the API serves (the all-time leaderboard today,
 * match history and friends later). Shared rather than server-local because the client builds
 * its own request objects: if the two sides disagreed about `MAX_LIMIT`, the browser would ask
 * for a page the server rejects and the failure would surface as a validation error, not as a
 * clamp.
 *
 * Distinct from `LEADERBOARD_SIZE`, which is the in-room top-N replicated over the WebSocket.
 */
export const PAGINATION = {
  /** What a caller gets when it names no limit — one screen of rows on a phone. */
  DEFAULT_LIMIT: 20,
  /** Hard ceiling. Keyset pagination makes deep paging cheap, so pages stay small. */
  MAX_LIMIT: 50,
} as const;
